"use client";

import Markdown from "@/utils/Markdown";
import { handleImgResponse } from "@/utils/utility";
import Image from "next/image";
import Link from "next/link";
import useIsMobile from "../Shared/Media/hooks";

export default function ServicesBanner({ banner }: any) {
  const isMobile = useIsMobile();
  return (
    <>
      <section className="md:mb-24">
        <div
          className="w-full md:h-[35rem] h-[20rem] bg-center bg-cover bg-no-repeat grid"
          style={{
            backgroundImage: !isMobile
              ? `url(${handleImgResponse(banner?.desktopBg)})`
              : "none",
          }}
        >
          <div className="md:ml-[3rem] my-auto mx-auto md:col-start-2 md:col-span-8">
            <h2 className="mb-6">
              <Markdown>{banner?.title}</Markdown>
            </h2>
            <div
              className={`text-white py-8 bdy-txt-5`}
            >
              <Markdown>{banner?.text}</Markdown>
            </div>

            <Link href={banner?.CTA?.link || ""} className="mt-6">
              <button className="btn-primary">{banner?.CTA?.text}</button>
            </Link>
          </div>
        </div>

        {isMobile && (
          <div className="flex justify-center">
            <Image
              src={handleImgResponse(banner?.mobileBg)}
              width={400}
              height={400}
              alt="bg"
            />
          </div>
        )}
      </section>
    </>
  );
}
